import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  Input,
  OnInit
} from '@angular/core';
import { ComponentColors, ComponentSizes } from '@pc/common';
import { IconComponent } from '@pc/icon';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'button[pcButton],input[type="button"][pcButton],input[type="submit"][pcButton],a[pcButton]',
  templateUrl: './button.component.html',
  standalone: true,
  exportAs: 'pcButton',
  styleUrls: ['./button.component.scss'],
  imports: [CommonModule, IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonComponent implements OnInit {
  @Input() icon = '';

  @Input() size: ComponentSizes = 'small';

  @Input() color: ComponentColors = 'primary';

  @Input() toggleButton = false;

  @Input()
  @HostBinding('class.full-width')
  hasFullWidth = false;

  @HostBinding('class') get class(): string {
    return `color--${this.color} size--${this.size}`;
  }

  @HostBinding('class.active')
  get active(): boolean {
    return this.toggleButton;
  }

  @HostBinding('class.with-icon')
  public withIcon = false;

  @HostBinding('class.icon-btn')
  public onlyIcon = false;

  get hasIcon(): boolean {
    return Boolean(this.icon);
  }

  constructor(
    private el: ElementRef<HTMLButtonElement>,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.setIconProps();
  }

  private setIconProps(): void {
    if (this.hasIcon && this.elementHasChildTextNode(this.el.nativeElement)) {
      this.withIcon = true;
    } else if (this.hasIcon) {
      this.onlyIcon = true;
    }

    this.cd.markForCheck();
  }

  protected elementHasChildTextNode(element: Element): boolean {
    const { childNodes } = element;

    for (const childNode of childNodes as unknown as ChildNode[]) {
      const node = childNode as Node;

      if (node.nodeType === Node.TEXT_NODE && node.nodeValue && node.nodeValue.length > 0) {
        return true;
      }
    }

    return false;
  }
}
